import { ActionStatus } from "../enums";

export interface RequestAppraisal {
  employee_id: string;
  first_name: string;
  last_name: string;
  department: string;
  project_managerid: string;
  reason: string;
  attendence_rating: string;
  workethics_rating: string;
  qualityofwork_rating: string;
  leadershipqualities_rating: string;
  communication_rating: string;
  problemsolving_rating: string;
  attendence_comment: string;
  workethics_comment: string;
  qualityofwork_comment: string;
  leadership_comment: string;
  communication_comment: string;
  problemsolving_comment: string;
  status: string;
}

export interface PmAddAppraisal {
  request_id: string;
  attendence_rating: string;
  workethics_rating: string;
  qualityofwork_rating: string;
  leadershipqualities_rating: string;
  communication_rating: string;
  problemsolving_rating: string;
  attendence_comment: string;
  workethics_comment: string;
  qualityofwork_comment: string;
  leadership_comment: string;
  communication_comment: string;
  problemsolving_comment: string;
  reason: string;
  status: ActionStatus;
}

export interface AppraisalRequestList {
  attendence_comment: string;
  attendence_rating: number;
  communication_comment: string;
  communication_rating: number;
  created_on: Date | string;
  customer_id: number;
  department: string;
  employee_id: string;
  first_name: string;
  last_name: string;
  leadership_comment: string;
  leadershipqualities_rating: number;
  problemsolving_comment: string;
  problemsolving_rating: number;
  project_managerid: string;
  qualityofwork_comment: string;
  qualityofwork_rating: number;
  reason: string;
  request_id: string;
  status: string;
  user_id: string;
  workethics_comment: string;
  workethics_rating: number;
  pm_firstname: string;
  pm_lastname: string;
  managerRating: ManagerRating[];
  project_managername: string;
}

export interface SelfAppraisalList {
  appraised_by_firstname: string;
  appraised_by_lastname: string;
  apprasedby: any[];
  attendence_comment: string;
  attendence_rating: number;
  communication_comment: string;
  communication_rating: number;
  created_on: Date | string;
  customer_id: string;
  department: string;
  employee_id: string;
  first_name: string;
  last_name: string;
  leadership_comment: string;
  leadershipqualities_rating: number;
  problemsolving_comment: string;
  problemsolving_rating: number
  project_managerid: string;
  qualityofwork_comment: string;
  qualityofwork_rating: number;
  reason: string;
  request_id: string;
  selfrating: number | any;
  managerRating: ManagerRating[];
  status: string;
  user_id: string;
  usr_designation: string;
  workethics_comment: string;
  workethics_rating: number;
  manrating: number | any;
  appraised_by_name: string;
  appraised_by_department: string;
}

export interface ManagerRating {
  appraisal_id: string;
  attendence_comment: string;
  attendence_rating: number;
  communication_comment: string;
  communication_rating: number;
  created_on: Date | string;
  leadership_comment: string;
  leadershipqualities_rating: number;
  manrating: number | any;
  pm_firstname: string;
  pm_lastname: string;
  problemsolving_comment: string;
  problemsolving_rating: number;
  qualityofwork_comment: string;
  qualityofwork_rating: number;
  reason: string;
  request_id: string;
  user_department: string;
  user_id: string;
  workethics_comment: string;
  workethics_rating: number;
}